$(document).ready(function () {
    $('#savePAFile').on('show.bs.modal', function () {
        var modal = $(this);
        var assignment_title  = $(modal).find('select[name="title_id"]');
        var custom_title      = $(modal).find('.custom_title');
        var subtype           = $(modal).find('.subtype');
        var upload_form       = $(modal).find('form');
        var duplicate_warning = $(modal).find('.no-duplicates-allowed');

        $(duplicate_warning).hide();

        $(custom_title).hide();
        $(subtype).hide();

        $(assignment_title).change(function () {
            if ($(assignment_title).val() == 'custom') {
                $(custom_title).show();
                $(subtype).show();
            } else {
                $(custom_title).hide();
                $(subtype).hide();
            }

            // Show the warning about duplicate submissions if the student
            // Is about to submit to an assignment that doesn't allow
            // Duplicate submissions
            if ($(this).find(':selected').data('duplicates') == 0) {
                $(duplicate_warning).show();
            } else {
                $(duplicate_warning).hide();
            }
        });
        $.validator.addMethod('checkTitle', function (value, element, param) {
            if (value === '0') {
                return false;
            }

            return true;
        }, 'Please select an assigment');
        $(upload_form).validate({
            ignore: ':hidden, [contenteditable="true"]:not([name])',
            debug: false,
            errorClass: 'danger',
            rules: {
                title_id: { required: true },
                group: {
                    required: {
                        depends: function () {
                            return $('select[name="title_id"]').val() !== 'custom';
                        },
                    },
                },
                subtype: {
                    required: {
                        depends: function () {
                            return $('select[name="title_id"]').val() === 'custom';
                        },
                    },
                },
                custom_title: {
                    required: {
                        depends: function () {
                            return $('select[name="title_id"]').val() === 'custom';
                        },
                    },
                },
                userfile: { required: true },
            },
            submitHandler: function (form) {
                form.submit();
            },
        });
    });

    $('#eportfolio-feedback').on('show.bs.modal', function (e) {
        var file = $(e.relatedTarget).data('file');
        $('.file-title').empty().append(file.title);
        $('.heading span').empty().append(' (' + file.feedback.lastmodifiedby_realname + ')');
        $('.feedback-date').empty().append('<small>Posted:' + dayjs(parseInt(file.feedback.lastmodifieddate) * 1000).format(LONGDATE + ' ' + TIME) + '</small>');
        $('.feedback-replace').empty().append(file.feedback.feedback.replace('\n', '<br>'));
    });

    $('select[name="paBlock"]').on('change', function () {
        if ($(this).val()) {
            var url = $(location).attr('href');
            var pagename = 'studentdashboard';
            var allParameters = url.substring(url.lastIndexOf(pagename) + (pagename.length + 1));
            var parameter = allParameters.split('/');
            if (parameter.length == 3) {
                window.location = base_url + 'eportfolio/studentdashboard/' + $(this).val() + '/' + parameter[1] + '/'  + parameter[2];
            } else {
                window.location = base_url + 'eportfolio/studentdashboard/' + $(this).val();
            }
        }
    });

    $('.editsubmissionfeedback-btn').on('click', function () {
        $('#AddEditSubmissionFeedbackModal').modal('show');
        var file = $(this).parents('.file-row').data('file');
        $('span.title').empty().append(file.title);
        $('#submissionfeedbackform').attr('action', base_url + 'eportfolio/savefeedback/' + file.id);
        $('input[type="radio"][name="grade"][value="' + file.feedback.grade + '"]').prop('checked', 'checked');
        $('textarea[name="feedback"]').val(file.feedback.feedback);
    });

    $('.edittutorfeedback-btn').on('click', function () {
        $('#EditTutorMarkModal').modal('show');
        var feedback = $(this).parents('.feedback-row').data('feedback');
        $('input[type="hidden"][name="id"]').val(feedback.id);
        $('input[type="radio"][name="grade"][value="' + feedback.grade + '"]').prop('checked', 'checked');
        $('textarea[name="feedback"]').val(feedback.feedback);
    });

    $('.viewReleasedTutorMark-btn').on('click', function () {
        $('#ReleasedTutorMarkModel').modal('show');
        var feedback = $(this).parents('.feedback-row').data('feedback');
        $('span.tutorname').empty().append('(' + feedback.tutorname + ')');
        $('span.block').empty().append(feedback.block == null ? feedback.firstname + ' ' + feedback.lastname : 'Block ' + feedback.block);
        $('p.posted span').empty().append(dayjs.unix(feedback.lastmodifieddate).format('MMMM Do YYYY LT'));
        $('p.feedback').empty().append(feedback.feedback);
    });
});
